module.exports = __webpack_public_path__ + "static/media/YM58_5.074c35b2.jpg";